import { defineMessages } from 'react-intl';

const messages = defineMessages({
  linkDashboard: {
    defaultMessage: 'Dashboard'
  },
  linkBookings: {
    defaultMessage: 'Bookings'
  },
  linkBookingRoomNights: {
    defaultMessage: 'Room Nights'
  },
  linkBookingFolios: {
    defaultMessage: 'Folios'
  },
  linkBookingPaymentRecords: {
    defaultMessage: 'Chargesheets'
  },
  linkBookingVirtualCreditCard: {
    defaultMessage: 'Virtual Credit Card'
  },
  linkBookingTickets: {
    defaultMessage: 'Tickets'
  },
  linkBookingRateCards: {
    defaultMessage: 'Rate Cards'
  },
  linkTickets: {
    defaultMessage: 'Tickets'
  },
  linkCustomers: {
    defaultMessage: 'Customers'
  },
  linkCustomersSettings: {
    defaultMessage: 'Settings / Config'
  },
  linkCustomerMember: {
    defaultMessage: 'Member'
  },
  linkCustomerMembers: {
    defaultMessage: 'Members'
  },
  linkCustomerPaymentIds: {
    defaultMessage: 'Payment IDs'
  },
  linkCustomerRates: {
    defaultMessage: 'Rates Settings'
  },
  linkCustomerPreferences: {
    defaultMessage: 'Preferences'
  },
  linkCustomerFeatures: {
    defaultMessage: 'Feature Settings'
  },
  linkSuppliers: {
    defaultMessage: 'Suppliers'
  },
  linkMargins: {
    defaultMessage: 'Margins'
  },
  linkSupplierProperties: {
    defaultMessage: 'Properties'
  },
  linkUsers: {
    defaultMessage: 'Users'
  },
  linkRoles: {
    defaultMessage: 'Roles'
  },
  linkPermissions: {
    defaultMessage: 'Permissions'
  },
  linkAccounting: {
    defaultMessage: 'Accounting'
  },
  linkCOGS: {
    defaultMessage: 'COGS'
  },
  linkChargesheets: {
    defaultMessage: 'Chargesheets'
  },
  linkVirtualCardManagement: {
    defaultMessage: 'VCCs'
  },
  linkJoin: {
    defaultMessage: 'Request to Join'
  },
  linkHelpSupport: {
    defaultMessage: 'Help & Support'
  },
  linkSignOut: {
    defaultMessage: 'Sign Out'
  },
  linkCustomerPendingRequests: {
    defaultMessage: 'Pending Requests'
  },
  linkBids: {
    defaultMessage: 'Bids & Offers'
  },
  linkMProperties: {
    defaultMessage: 'Manage Properties'
  },
  linkRooms: {
    defaultMessage: 'Room Templates'
  },
  linkRates: {
    defaultMessage: 'Rate Plans'
  },
  linkProperties: {
    defaultMessage: 'Properties'
  },
  linkMOrganization: {
    defaultMessage: 'Manage Organization'
  },
  linkOSettings: {
    defaultMessage: 'Organization Settings'
  },
  linkAnalytics: {
    defaultMessage: 'Analytics'
  },
  linkHome: {
    defaultMessage: 'Home'
  },
  linkAccountSettings: {
    defaultMessage: 'Account Settings'
  },
  linkContact: {
    defaultMessage: '1-844-590-5465'
  },
  linkRolesAndPermissions: {
    defaultMessage: 'Roles and Permissions'
  },
  linkPlatformSettings: {
    defaultMessage: 'Platform Settings'
  },
  linkReconciliation: {
    defaultMessage: 'Reconciliation'
  },
  linkInvoices: {
    defaultMessage: 'Invoices'
  },
  linkVendorBills: {
    defaultMessage: 'Vendor Bills'
  },
  erpConfigurationPage: {
    defaultMessage: 'ERP Configuration'
  },
  linkTaxesAndFees: {
    defaultMessage: 'Taxes & Fees'
  },
  linkRateCards: {
    defaultMessage: 'Rate Cards'
  },
  linkApprovals: {
    defaultMessage: 'Approvals'
  },
  linkAccountManagement: {
    defaultMessage: 'Account Management'
  },
  linkCardManagement: {
    defaultMessage: 'Card Management'
  },
  linkConnectionManagement: {
    defaultMessage: 'Connection Management'
  },
  linkFeatureFlags: {
    defaultMessage: 'Feature Flags'
  },
  linkAllFolios: {
    defaultMessage: 'All Folios'
  },
  linkFoliosByBookings: {
    defaultMessage: 'Folios By Booking'
  },
  linkMissingFolios: {
    defaultMessage: 'Missing Folios'
  },
  linkChargesheetPreview: {
    defaultMessage: 'Preview'
  },
  linkChargesheetFolios: {
    defaultMessage: 'Folio List'
  },
  linkTaxTemplates: {
    defaultMessage: 'Tax Templates'
  },
  linkTaxesFees: {
    defaultMessage: 'Taxes & Fees'
  },
  linkERPDashboard: {
    defaultMessage: 'Error Dashboard'
  },
  linkERPCustomers: {
    defaultMessage: 'Customers'
  },
  linkERPSuppliers: {
    defaultMessage: 'Suppliers'
  },
  linkERPGLCodes: {
    defaultMessage: 'GLCodes'
  },
  linkERPTaxCodes: {
    defaultMessage: 'TaxCodes'
  },
  linkERPItemCodes: {
    defaultMessage: 'ItemCodes'
  },
  linkSupplierPropertyAddRooms: {
    defaultMessage: 'Rooms'
  },
  linkSupplierPropertySettings: {
    defaultMessage: 'Settings / Config'
  },
  linkSupplierPropertyRooms: {
    defaultMessage: 'Rooms'
  },
  linkSupplierPropertyConnection: {
    defaultMessage: 'Connection'
  },
  linkSupplierPropertyRateMarkupLogs: {
    defaultMessage: 'Rate & Markup Logs'
  },
  linkRateEngineManagement: {
    defaultMessage: 'Rate Engine Management'
  },
  linkTrackingCodes: {
    defaultMessage: 'Tracking Codes'
  }
});

export default messages;
